import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import CompositiontemplateDashboard from '../CompositiontemplateDashboard';
import { getListAPI as getCompositiontemplateList } from 'components/compositiontemplate/CompositiontemplateAPI';
import { setCompositiontemplateList, setCompositiontemplateDashboardCompositiontemplateList } from 'store/slice/PharmaSlice';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function CompositiontemplatePageImpl() {
    const dispatch = useDispatch();
    const { compositiontemplateList} = useSelector((state)=>state.pharmaslice);
    
    const getCompositiontemplateListSuccess = (list) =>{dispatch(setCompositiontemplateList(list));}
    useEffect(() => {
        dispatch(openDrawer(false));
        getCompositiontemplateList(()=>{}, getCompositiontemplateListSuccess);
    },[]);
    useEffect(()=>{
        setCompositiontemplateDashboardCompositiontemplateList( compositiontemplateList);
    },[ compositiontemplateList])

    return (
        < CompositiontemplateDashboard />
    )

}